import React, { useEffect, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Button from 'components/Button/Button';
import Link from 'components/Link/Link';
import SettingsContext from 'contexts/SettingsContext';
import useCompetitionEntryContext from 'contexts/useCompetitionEntryContext';
import competitionEntryService from 'services/competitionEntryService';
import analyticsService from 'services/analyticsService';
import useEffectOnce from 'hooks/useEffectOnce';

import NpsBanner from 'components/NpsBanner/NpsBanner';
import timer from 'utils/timer';

import './Thankyou.scss';

import SummaryTsandCs from 'components/SummaryTsandCs/SummaryTsandCs';
import KeyVisual from 'containers/Home/KeyVisual';


export default () => {
  let { entryPublicId } = useParams();
  let [settings, setSettings] = React.useContext(SettingsContext);
  let compState = settings.competitionStatus.openState;
  let competitionIsOpen = compState === "Open";
  let competitionEntryContext = useCompetitionEntryContext();
  //let [entry, setEntry] = useState(competitionEntryContext.result);
  let [entry, setEntry] = useState("");
  let [showNps, setShowNps] = useState(null);


  useEffect(() => {
    async function fetchData() {
      await competitionEntryService.getCompetitionEntry(entryPublicId)
        .then((result) => {
          if (result) {
            setEntry(result);

            if (result.nps != null) {
              setShowNps(false);
            } else {
              timer.delay(2500).then(() => setShowNps(true));
            }


            var email = competitionEntryContext.email;
            //Had to go here, as not triggered on last page
            if (email != null) {
              // Save email to DataLayer - GTM uses this to pass to Lytics (Only if the user has accepted targeting cookies)
              analyticsService.logEvent("forms", "Forms", {
                action: "EmailCapture",
                email
              });

              analyticsService.logEvent("forms", "Forms", {
                action: "RegistrationSuccess"
              });

              if (entry.hasWon) {
                analyticsService.logEvent('event', 'Prize', {
                  action: entry.prizePublicId
                });
              }
            }
          }
        })
        .catch(err => console.log(err));
    }

    if (entryPublicId && !entry) {
      fetchData();
    }
  }, [entry]);


  // useEffectOnce(() => {

  //   timer.delay(2500).then(() => setShowNps(true));
  // });

  // if (competitionIsOpen && ((entry !== null && !entry.entryPublicId) || !entryPublicId)) {
  //   return (
  //     <Redirect to="/" />
  //   )
  // }

  const renderNpsBanner = (entryPublicId) => {
    if (!entryPublicId) return null;
    return <NpsBanner onClose={() => setShowNps(false)} competitionEntryPublicId={entryPublicId} show={showNps} />
  }

  return (
    <>
      {
        (entryPublicId && !entry) ? (
          <>
            <Helmet>
              <meta charSet="utf-8" />
              <title>Error | Philadelphia - WIN a brunch in New York</title>
            </Helmet>
            <section className='thankyou'>
              <div className="layout-general layout-wrapper layout-general--full">
                <div className="layout-container layout-container--center layout-general--slim">
                  <h1 className="type-h1 type-h1--xl">Error!</h1>
                  <p className="thankyou__para">
                    Sorry, something went wrong.
                  </p>
                  <Button type="button" title="Back to homepage" href="/" className="mt-20 button--blue" />
                </div>
              </div>
            </section>
          </>
        ) : (
          <>
            <Helmet>
              <meta charSet="utf-8" />
              <title>Thank you | Philadelphia - WIN a brunch in New York</title>
            </Helmet>
            <section className="thankyou">
              <div className='layout-general layout-general--full'>

                <KeyVisual />
                
                <div className="layout-container layout-container--center">
                  <h1 className="type-h1">Thanks for entering! If you’re a winner, we’ll reach out to let you know!</h1>

                  {settings.country === "ROI" ?
                    (<p className="thankyou__para">
                      In the meantime, check out our website for Philly-inspired recipes to create your own delicious brunch at home.
                    </p>)
                    :
                    (<p className="thankyou__para">
                      Until then, tuck into our DELI-cious new partnership with The New York Bakery Co. and discover your perfect combination of mouthwatering bagel, creamy Philly, and… fresh Avocado? Chopped chives? Crispy salad? Zesty Tuna? Red Onion? Or why not all together?
                    </p>)

                  }

                  {settings.country === "ROI" ?
                    (<Link
                      analytics={{ evnt: "siteLink", category: "ThankYouPage", action: "OpenPhillydeliWebsite", value: "Open Phillydeli website link" }}
                      to="https://phillydeli.co.uk/recipes" target="_blank" lozenge title="phillydeli.co.uk/recipes">Brunch inspo</Link>
                    )
                    :
                    (
                      <>
                        <Link
                          analytics={{ evnt: "siteLink", category: "ThankYouPage", action: "OpenPhillydeliWebsite", value: "Open Philadelphia website link" }}
                          to="https://phillydeli.co.uk" target="_blank" lozenge title="phillydeli.co.uk" >Visit the philly deli</Link>
                        <Link
                          analytics={{ evnt: "siteLink", category: "ThankYouPage", action: "OpenPhillydeliWebsite", value: "Open Phillydeli website link" }}
                          to="https://phillydeli.co.uk/recipes" target="_blank" lozenge title="phillydeli.co.uk/recipes" >Build your bagel</Link>
                      </>
                    )
                  }
                </div>
                
               
                {renderNpsBanner(entryPublicId)}
              </div>
            </section>
          </>
        )

      }

    </>

  );
}
